import { createEntityAdapter } from "@reduxjs/toolkit";

import apiSlice from "../api/apiSlice";

const loadsAdapter = createEntityAdapter({});

const initialState = loadsAdapter.getInitialState({});

export const loadsForecastApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getLoadsForecastByCommunityId: builder.query({
      query: (communityId) => ({
        url: `/communities/${communityId}/loads_forecast`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      transformResponse: (responseData) => {
        if (responseData) {
          return loadsAdapter.setAll(initialState, responseData);
        }
        return [];
      },
      providesTags: (result) => {
        if (result?.ids) {
          return [
            { type: "LoadForecast", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Load", id })),
          ];
        }
        return [{ type: "LoadForecast", id: "LIST" }];
      },
    }),
    getLoadsForecastByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        time,
        cpe,
        meterType,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/loads_forecast/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${cpe ? `&meter_id=${cpe}` : ""}` +
          `${meterType ? `&meter_type=${meterType}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "LoadForecast", id: "LIST" }],
    }),
    getLoadsForecastKpisByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/loads_forecast/metrics/kpis?` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Loads-Kpis" }],
    }),
    getAggregatedLoadsForecastByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate, granularity }) => ({
        url:
          `/communities/${communityId}/loads_forecast?` +
          `granularity=${granularity}&` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Loads-Community" }],
    }),
    getMetersLoadsForecastByCommunityId: builder.query({
      query: ({ communityId, startDate, endDate, granularity }) => ({
        url:
          `/communities/${communityId}/loads_forecast/loadsbymeter?` +
          `granularity=${granularity}&` +
          `start_date=${startDate}&` +
          `end_date=${endDate}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: [{ type: "Metrics", id: "Loads-Meters" }],
    }),
    /* POST */
    addNewLoadsForecast: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();

        formData.append("file_upload", file, file.name);

        return {
          url: `/communities/${communityId}/loads_forecast/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "LoadForecast", id: "LIST" }],
    }),
    /* DELETE */
    deleteLoadsForecast: builder.mutation({
      query: ({ communityId, startDate, endDate }) => {
        const params = new URLSearchParams();
        if (startDate) params.append("start_date", startDate);
        if (endDate) params.append("end_date", endDate);
        const qs = params.toString();
        return {
          url: `/communities/${communityId}/loads_forecast${qs ? `?${qs}` : ""}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "LoadForecast", id: "LIST" }],
    }),
  }),
});

export const {
  useGetLoadsForecastByCommunityIdQuery,
  useGetLoadsForecastByCommunityIdPaginationQuery,
  useAddNewLoadsForecastMutation,
  useDeleteLoadsForecastMutation,
  useGetLoadsForecastKpisByCommunityIdQuery,
  useGetAggregatedLoadsForecastByCommunityIdQuery,
  useGetMetersLoadsForecastByCommunityIdQuery,
} = loadsForecastApiSlice;
